/**
 * Generate dynamic dot paths for Mitek SDK
 *
 * @param {string} path : The path to location
 * @param {string} letter : which letter want to count
 * @returns {string} dot-path like `../../../`
 */

export const generateDynamicDotByPath = (path = '', letter = '/') => {
  // creating regex
  const regex = new RegExp(letter, 'g');

  const count = path.match(regex)?.length || 0;
  // generate dot-path
  return '../'.repeat(count > 0 ? count - 1 : 0);
};
